import React, { useEffect, useState } from 'react';
import { ChromePicker, SketchPicker } from 'react-color';
import "../styles.css";

export const ColorPickerWithLabel = ({ pickerId, defaultColor, handleColorChangeParent, defaultText = null }) => {
  const [color, setColor] = useState('#7F1032'); // Initial color
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  useEffect(() => {
    setColor(defaultColor);
  }, [defaultColor])

  // Toggle the color picker popup
  const handleColorPicker = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  // Handle color change
  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
    handleColorChangeParent(pickerId, newColor.hex)
  };

  return (
    <div>
      {/* Div and label that shows selected color */}
      <div className='colorpicker-div'>
        <div className='color-div' style={{ backgroundColor: color, cursor: 'pointer' }} onClick={handleColorPicker}></div>
        <label className='color-label'>{defaultText !== null ? defaultText : color.toUpperCase()}</label>
      </div>

      {/* Color picker popup */}
      {displayColorPicker && (
        <div style={{ position: 'absolute', zIndex: 2 }}>
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            onClick={handleColorPicker} // Close picker when clicking outside
          />
          <SketchPicker 
            color={color} 
            onChange={handleColorChange}
            disableAlpha={true}
            presetColors={[
              {'color': '#d9534f', 'title': 'Red'},
              {'color': '#EF7617', 'title': 'Orange'},
              {'color': '#FFC83D', 'title': 'Yellow'},
              {'color': '#31B452', 'title': 'Green'},
              {'color': '#0000FF', 'title': 'Blue'},
              {'color': '#000000', 'title': 'Black'},
              {'color': '#cccccc', 'title': 'Grey'},
              {'color': '#A9A9A9', 'title': 'Dark Grey'},
            ]}
            />
        </div>
      )}
    </div>
  );
};
